import { render, staticRenderFns } from "./react-email.vue?vue&type=template&id=196ca722&scoped=true&"
import script from "./react-email.vue?vue&type=script&lang=js&"
export * from "./react-email.vue?vue&type=script&lang=js&"
import style0 from "./react-email.vue?vue&type=style&index=0&id=196ca722&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196ca722",
  null
  
)

export default component.exports